import React, { useState } from "react";
import "@styles/components/ui/AccordionRow.scss";
import { Box, Typography } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AddIcon from "@mui/icons-material/Add";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
const AccordionRow = ({
  summaryTitle,
  summaryValue,
  summaryRight,
  details = [],
  isOpen: controlledOpen,
  onToggle,
  iconType = "arrow", // 🆕 新增 prop
}) => {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);

  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : uncontrolledOpen;

  const handleClick = () => {
    if (isControlled) {
      onToggle?.();
    } else {
      setUncontrolledOpen((v) => !v);
    }
  };

  // 🆕 根據 iconType 決定 icon
  const renderIcon = () => {
    if (iconType === "plusminus") {
      return open ? (
        <HorizontalRuleIcon sx={{ fontSize: 24, color: "#000" }} />
      ) : (
        <AddIcon sx={{ fontSize: 24, color: "#000" }} />
      );
    }
    // 預設 arrow
    return open ? (
      <ArrowDropUpIcon sx={{ fontSize: 30, color: "#000" }} />
    ) : (
      <ArrowDropDownIcon sx={{ fontSize: 30, color: "#000" }} />
    );
  };

  return (
    <Box className="accrdion-row-container" onClick={handleClick}>
      <Box className="data-row-catalog">
        <Box className="data-row-title">
          <Typography className="row-title">{summaryTitle}</Typography>
          <Typography className="row-title-value">{summaryValue}</Typography>
        </Box>
        <Box className="data-row-right">
          <Typography className="right-value">{summaryRight}</Typography>
          {renderIcon()}
        </Box>
      </Box>

      {open && (
        <Box className="data-row-detail">
          {details.map(({ label, value }, idx) => (
            <Box className="data-row" key={idx}>
              {label && value && (
                <>
                  <Typography className="detail-label">{label}:</Typography>
                  <Typography className="detail-data-value">{value}</Typography>
                </>
              )}
              {!label && value && (
                <Typography className="detail-data-value-full-row">
                  {value}
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default AccordionRow;
